import React from "react"

import type { Element } from "react"

import type { Role } from "../../types/types"
import OrganisationListItem from "./OrganisationListItem"
import StakeholderItemExpanded from "./StakeholderItemExpanded"
import UserListItem from "./UserListItem"

type Props = {
    isExpanded: boolean,
    id: string,
    activeStakeholderId: string,
    highlightedId: string,
    roles: Array<Role>,
    filteredRole: string,
    type: string,
    onClick: void => void
}

const StakeholderListItem = (props: Props) => {
    if (props.isExpanded && props.id === props.activeStakeholderId) {
        return (
            <StakeholderItemExpanded
                id={props.id}
                isExpanded={props.isExpanded}
                listItem={getListItem(props, false, true)}
                toggleExpansion={props.onClick}
            />
        )
    } else if (props.highlightedId) {
        return getListItem(props, true, false)
    } else {
        return getListItem(props, false, false)
    }
}

function getListItem(
    props: Props,
    isExpandable: boolean,
    isExpanded: boolean
): Element<any> {
    let expandedProps = {
        ...props,
        isExpandable: isExpandable,
        isExpanded: isExpanded,
        dataCy: "stakeholderListItem"
    }

    const ComponentName =
        props.type === "Organisation" ? OrganisationListItem : UserListItem

    if (props.filteredRole === "Organisation") {
        expandedProps.showImage = false
    }

    return <ComponentName {...expandedProps} />
}

export default StakeholderListItem
